const API = '/api';

export interface Informacion {
  id: number;
  nombre_negocio: string;
  telefono?: string;
  whatsapp?: string;
  whatsapp_2?: string;
  email?: string;
  direccion?: string;
  gps_lat?: number;
  gps_lng?: number;
  horario?: string;
  facebook_url?: string;
  instagram_url?: string;
}

export interface Categoria {
  id: number;
  nombre: string;
  icono?: string;
  orden: number;
}

export interface Producto {
  id: number;
  nombre: string;
  descripcion?: string;
  precio: number;
  precio_oferta?: number;
  categoria_id?: number;
  imagen_url?: string;
  destacado: boolean;
  disponible: boolean;
  plato_del_dia?: boolean;
  dias_disponibles?: string; // "lunes" o "martes,viernes"; vacío = todos los días
  orden: number;
}

export async function obtenerInformacion(): Promise<Informacion | null> {
  try {
    const r = await fetch(`${API}/informacion/`);
    if (!r.ok) return null;
    return await r.json();
  } catch { return null; }
}

export async function obtenerCategorias(): Promise<Categoria[]> {
  try {
    const r = await fetch(`${API}/categorias/`);
    if (!r.ok) return [];
    return await r.json();
  } catch { return []; }
}

export async function obtenerProductos(): Promise<Producto[]> {
  try {
    const r = await fetch(`${API}/productos/`);
    if (!r.ok) return [];
    return await r.json();
  } catch { return []; }
}

// Días de la semana en español, en el mismo formato que se guarda en la BD
export const DIAS_SEMANA = ['domingo', 'lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'];

export function diaDeHoy(): string {
  return DIAS_SEMANA[new Date().getDay()];
}

export function productoDisponibleHoy(p: Producto): boolean {
  if (!p.dias_disponibles) return true; // sin restricción = todos los días
  const dias = p.dias_disponibles.split(',').map(d => d.trim());
  return dias.includes(diaDeHoy());
}

export interface Banner {
  id: number;
  texto?: string;
  imagen_url?: string;
}

export async function obtenerBannersPromo(): Promise<Banner[]> {
  try {
    const r = await fetch(`${API}/banners/promo`);
    if (!r.ok) return [];
    return await r.json();
  } catch { return []; }
}

export async function obtenerBannerInfobar(): Promise<Banner | null> {
  try {
    const r = await fetch(`${API}/banners/infobar`);
    if (!r.ok) return null;
    return await r.json();
  } catch { return null; }
}
